export default __webpack_public_path__ + "static/media/img_baseCotton_cotton_p.5fc86c1c.jpg";